module.exports = __webpack_public_path__ + "static/media/mig0828_logo.edd685df.png";